import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { BinaryDataset } from 'app/model/dataset/binary.dataset';
import { FormatTypeCopySource } from './format-type.copysource';

@Metamodel.model({
    name: 'BinarySource',
    display: [],
    tags: { datasetModel : [Metamodel.modelFor(BinaryDataset)]}
})
export class BinaryCopySource extends FormatTypeCopySource {
}
